<kilowant-header [isBuyer]="true"
                 [showAccountList]="false"
                 [myKilowant]="(user.isAdvisor)?true:false" 
                 [showTtitleAsSecond]="(user.isAdvisor)?true:false"
                 title="AI Tasks"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
    @if (pageLoaded()) {
    <div class="form buyer">
        <div class="account-info-block mt-20">
            <p class="card-block-background f18">
                Nonstop Shop &#174; AI
                @if (ifAnyTaskActive()) {
                <span>ON</span>
                }
                @if (!ifAnyTaskActive()) {
                <span>OFF</span>
                }
            </p>
            <label class="small-switch">
                <input type="checkbox" [checked]="ifAnyTaskActive()" (change)="changeTaskActivation()">
                <span></span>
            </label>
            <div class="visible p-20" [class]="(ifAnyTaskActive())?'':'inactive'">
                <div class="f13">Never miss a savings opportunity! Nonstop Shop &#174; Al will search daily for future savings offers, and autonomously switch you to the lowest price plan.</div>
                @if (ifAnyTaskActive()) {
                <div class="bottom-sub-title mt-20">Select a Level of Autonomous Shopping</div>
                }
                @for (aiTask of activeTasks; track aiTask; let i = $index) {
                <div class="mt-20">
                    <div class="d-flex">
                        <div class="tile-bolt">{{aiTask.level}}</div>
                        <span class="auto link pt-1" [class]="(viewSubscription[i])?'':'view-closed'" (click)="viewSubscription[i] = !viewSubscription[i]; refreshView();">
                            <b *ngIf="aiTask.level==1">Short-Term Savings</b>
                            <b *ngIf="aiTask.level==2">Mid-Term Savings</b>
                            <b *ngIf="aiTask.level==3">Long-Term Savings</b>
                            <a [class]="(viewSubscription[i])?'collapse':'open'"></a>
                        </span>
                    </div>
                    @if (viewSubscription[i]) {
                    <div class="ml-30">
                        <div class="d-flex">
                            <div class="auto">
                                @if (aiTask.level==1) {
                                <div class="f13 mt-10">
                                    Captures maximum savings  yield seasonally up to 9 months in the future. Triggers during <span class="low">Low</span>, <span class="avg">Avg</span>, <span class="high">High</span> markets.
                                </div>
                                }
                                @if (aiTask.level==2) {
                                <div class="f13 mt-10">
                                    Captures maximum savings yield up to 18 months in the future. Triggers during <span class="low">Low</span> - <span class="avg">Avg</span> markets.
                                </div>
                                }
                                @if (aiTask.level==3) {
                                <div class="f13 mt-10">
                                    Captures maximum savings yield up to 36 months in the future. Triggers during <span class="low">Low</span> markets.
                                </div>
                                }
                            </div>
                        </div>
                        @if (ifAnyTaskActive()) {
                        <p class="mt-10">Subscribed Accounts - {{aiTask.accounts.length}} of {{accountsNotInAI.length}}</p>
                        <div class="auto">
                            <div class="checkbox-list"><label *ngIf="aiTask.accounts.length>0"><input type="checkbox" [checked]="selectedAll[i*2]" (click)="selectAllAccounts(i*2)"> Select All</label></div>
                            @for (aData of aiTask.accounts; track aData; let p = $index) {
                            <div class="checkbox-list" *ngIf="p<3 || showAllTasks[i*2]"><label><input [checked]="selectedAccounts[i*2].includes(aData.id)" (click)="switchAccountSelection(i*2, aData.id)" type="checkbox"> {{getName(aData)}}</label></div>
                            }
                            <div class="text-right" *ngIf="aiTask.accounts.length>3 && showAllTasks[i*2]"><a class="link" (click)="showAllTasks[i*2]=!showAllTasks[i*2]">show less</a></div>
                            <div class="text-right" *ngIf="aiTask.accounts.length>3 && !showAllTasks[i*2]"><a class="link" (click)="showAllTasks[i*2]=!showAllTasks[i*2]">show all {{aiTask.accounts.length}} accounts</a></div>
                        </div>
                        <div class="block-buttons full-width p-10 small-buttons" *ngIf="selectedAccounts[i*2]!=null && selectedAccounts[i*2].length>0">
                            <button (click)="switchAI(i*2, 0)">Deactivate</button>
                        </div>
                        <p class="mt-10">Unsubscribed Accounts - {{(accountsNotInAI.length - aiTask.accounts.length)}} of {{accountsNotInAI.length}}</p>
                        <div class="auto">
                            <div class="checkbox-list"><label *ngIf="(accountsNotInAI.length - aiTask.accounts.length)>0"><input type="checkbox" [checked]="selectedAll[i*2+1]" (click)="selectAllAccounts(i*2+1)"> Select All</label></div>
                            @for (iData of getAccountsNotInAITask(aiTask, accountsNotInAI); track iData; let p = $index) {
                            <div class="checkbox-list" *ngIf="(p<3 || showAllTasks[i*2+1])">
                                <label>
                                    <input [checked]="selectedAccounts[i*2+1].includes(iData.id)" [disabled]="aiTask.level!>1 && !iData.hasFullConsumption" (click)="switchAccountSelection(i*2+1, iData.id)" type="checkbox"> {{iData.accountName}}
                                    <a (click)="openConsumptionDialog(iData)" *ngIf="aiTask.level!>1 && !iData.hasFullConsumption" class="consumption-edit link"></a>
                                </label>
                            </div>
                            }
                            <div class="text-right" *ngIf="(accountsNotInAI.length - aiTask.accounts.length)>3 && showAllTasks[i*2+1]"><a class="link" (click)="showAllTasks[i*2+1]=!showAllTasks[i*2+1]">show less</a></div>
                            <div class="text-right" *ngIf="(accountsNotInAI.length - aiTask.accounts.length)>3 && !showAllTasks[i*2+1]"><a class="link" (click)="showAllTasks[i*2+1]=!showAllTasks[i*2+1]">show all {{(accountsNotInAI.length - aiTask.accounts.length)}} accounts</a></div>
                        </div>
                        <div class="block-buttons full-width p-10 small-buttons" *ngIf="selectedAccounts[i*2+1]!=null && selectedAccounts[i*2+1].length>0">
                            <button (click)="switchAI(i*2+1, aiTask.level!)">Subscribe</button>
                        </div>
                        <div>
                            <p>Creation Date</p>
                            <p class="mlr-20 f13"> {{aiTask.dateUpdated | date:'shortDate'}} </p>
                        </div>
                        }
                    </div>
                    }
                </div>
                @if (ifAnyTaskActive()) {
                <div class="consumption-info blue mt-10" *ngIf="i==0">
                    * Nonstop Shop ai Levels 2 and 3 require 12 months of consumption history to properly weight the cost benefit of our price plans. Click on the <span class="consumption-edit"></span> icon to enter consumption history.
                </div>
                }
                }
            </div>
        </div>
    </div>
    }
</div>